export const DISLIKED_JOB_STATE_CHANGED_EVENT = "DislikedJobStateChanged";

export type DislikedJobStateChangedSource = "viewjob" | "jobcard";

export type DislikedJobStateChangedEvent = {
  eventType: "DislikedJobStateChanged";
  jobKey: string;
  isDisliked: boolean;
  source: DislikedJobStateChangedSource;
  vjtk?: string;
};

export type DislikedJobStateChangedSubscription = {
  remove: () => void;
};
